<template>
	<div class="personal-center-container">
		<img class="personalBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="content-container">
			<BreadCrumb :routerLinks="routerLinks" currentTitle="订单详情"></BreadCrumb>
			<div class="orderInfoBox">
				<div class="goodsInfoBox">
					<div class="orderStatus" v-if="$route.query.type == 4">
						{{orderInfo.order && orderInfo.order.remove_status == 1 ? '已取消' : orderInfo.order && (orderInfo.order.status == 1 || orderInfo.order.status == 2) ? '进行中' : orderInfo.order && orderInfo.order.status == 3 ? '已完成' : '' }}
					</div>
					<div class="orderStatus" v-if="$route.query.type == 1">
						{{getImgStatusName(orderInfo)}}
					</div>
					<div class="orderStatus" v-if="$route.query.type == 2">
						{{getMakeStatusName(orderInfo)}}
					</div>
					<div class="orderStatus" v-if="$route.query.type == 3">
						{{getMarketStatusName(orderInfo)}}
					</div>
					<div class="userInfoBox" v-if="$route.query.type == 1 || $route.query.type == 2">
						<img class="avatar" :src="orderInfo.user.avatar"
							v-if="orderInfo.user && orderInfo.user.avatar" />
						<img class="avatar" src="../assets/defaultAvatar.png" v-else />
						<div class="nickname">
							{{orderInfo.user && orderInfo.user.user_nickname ? orderInfo.user.user_nickname : ''}}
						</div>
					</div>
					<div class="addressInfoBox" v-if="$route.query.type == 3 || $route.query.type == 4">
						<img class="icon" src="../assets/MyOrder/iconF.png" />
						<div class="addressInfo">
							<div class="address">
								{{orderInfo.order && orderInfo.order.sh_address ? orderInfo.order.sh_address : ''}}
							</div>
							<div class="namePhone">
								{{orderInfo.order && orderInfo.order.sh_name ? orderInfo.order.sh_name : ''}}
								{{orderInfo.order && orderInfo.order.sh_phone ? orderInfo.order.sh_phone : ''}}
							</div>
						</div>
					</div>
					<div class="integralOrder" v-if="$route.query.type == 4">
						<div class="imgInfoBox">
							<img class="makeGoodsImg" :src="orderInfo.goods.img"
								v-if="orderInfo.goods && orderInfo.goods.img" />
							<div class="imgInfo">
								<div class="goodsTitle ellipsis-1">
									{{orderInfo.goods && orderInfo.goods.title ? orderInfo.goods && orderInfo.goods.title : ''}}
								</div>
								<div class="goodsDesc">
									规格：{{orderInfo.goods && orderInfo.goods.specs ? orderInfo.goods && orderInfo.goods.specs : ''}}
								</div>
							</div>
						</div>
						<div class="goodsPrice">
							<div class="price">
								{{orderInfo.goods && orderInfo.goods.price ? orderInfo.goods.price : '0'}}积分
							</div>
							<div class="num">x{{orderInfo.order && orderInfo.order.num ? orderInfo.order.num : '0'}}
							</div>
						</div>
					</div>
					<div class="imgOrder" v-if="$route.query.type == 1 || $route.query.type == 3">
						<div class="imgInfoBox">
							<!-- 一个定制周边的图片，一个是常规图片订单的图片 -->
							<img class="makeGoodsImg" :src="orderInfo.goods.img"
								v-if="($route.query.type == 3 || $route.query.type == 1) && (orderInfo.goods && orderInfo.goods.img)" />
							<div class="imgInfo" v-if="$route.query.type == 3 || $route.query.type == 1">
								<div class="goodsTitle ellipsis-1">
									{{orderInfo.goods && orderInfo.goods.title ? orderInfo.goods.title : ''}}
								</div>
								<div class="goodsDesc ellipsis-2">
									{{orderInfo.goods && orderInfo.goods.content ? orderInfo.goods.content : ''}}
								</div>
								<div class="tips" v-if="$route.query.type == 3">
									<div class="tip">
										{{orderInfo.order && orderInfo.order.cid ? orderInfo.order.cid : ''}}
									</div>
								</div>
								<div class="tips" v-if="$route.query.type == 1 && orderInfo.goods.label">
									<div class="tip" style="margin-right: .1rem;"
										v-for="(item,index) in orderInfo.goods.label.split(',')" :key="index">
										{{item}}
									</div>
								</div>
							</div>
						</div>
						<div class="goodsPrice" v-if="$route.query.type == 1">
							<div class="price"><span class="unit">¥</span>{{orderInfo.pay_price}}</div>
							<div class="num">x{{orderInfo.count}}</div>
						</div>
					</div>
					<div class="goodsInfo" v-if="$route.query.type == 2">
						<div class="descTips">
							<div class="desc">
								定制一张赛博朋克风格的未来都市夜景图，
								高楼大厦布满全息广告屏以紫、蓝、粉冷光为主，
								搭配金属灰与机械部件的橙红色高光，
								酸雨淅沥滴落，远处有飞行器穿梭于霓虹雾霭中。
							</div>
							<div class="tips">
								<div class="tip" v-if="orderInfo.yongtu">
									{{orderInfo.yongtu}}
								</div>
							</div>
						</div>
						<div class="swiperBox">
							<ImgAallery :images="images" v-if="images && images.length" />
						</div>
					</div>
					<div class="timeBox" v-if="$route.query.type == 2">
						<div class="timeTitle">工期说明</div>
						<div class="timeDesc">
							{{orderInfo.hs_gongqi ? orderInfo.hs_gongqi : ''}}
						</div>
					</div>
				</div>
				<div class="payInfoBox" v-if="$route.query.type == 2">
					<div class="title">
						订单信息
					</div>
					<div class="orderPriceBox">
						<div class="itemTitle">订单金额</div>
						<div class="priceBox" style="margin-right: .1rem;">
							<div class="price">
								<span class="unit">¥</span>
								69.9
							</div>
						</div>
					</div>
					<div class="orderPriceBox" @click="dialogCouponVisible = true">
						<div class="itemTitle">代金券</div>
						<div class="priceBox">
							<div class="price">
								<span class="unit">¥</span>
								69.9
							</div>
							<img class="arrow" src="../assets/BuyNow/iconI.png" />
						</div>
					</div>
					<div class="payWayBox">
						<div class="payItem">
							<img class="checkIcon" src="../assets/BuyNow/iconF.png" />
							<!-- <img class="checkIcon" src="../assets/BuyNow/iconC.png" /> -->
							<img class="payIcon" src="../assets/BuyNow/iconE.png" />
							微信支付
						</div>
						<div class="payItem">
							<!-- <img class="checkIcon" src="../assets/BuyNow/iconF.png" /> -->
							<img class="checkIcon" src="../assets/BuyNow/iconC.png" />
							<img class="payIcon" src="../assets/BuyNow/iconD.png" />
							支付宝支付
						</div>
					</div>
					<div class="agreementBox">
						<img class="checkIcon" src="../assets/BuyNow/iconH.png" />
						<!-- <img class="checkIcon" src="../assets/BuyNow/iconA.png" /> -->
						我已阅读并同意 <span class="userAgreement" @click="userBuy = true">《用户购买须知协议》</span>
					</div>
					<div class="costButNow">
						<div class="costBox">
							实付款
							<div class="cost">
								<span class="unit">¥</span>
								69.8
							</div>
						</div>
						<div class="buyNow">立即购买</div>
					</div>
				</div>
				<div class="orderFinishInfoBox" v-if="$route.query.type == 1 || $route.query.type == 3">
					<div class="title">
						付款详情
					</div>
					<div class="priceBox">
						<div class="priceItem">
							商品总价
							<span>¥{{orderInfo.order && orderInfo.order.order_price ? orderInfo.order.order_price : '0'}}</span>
						</div>
						<div class="priceItem">
							优惠
							<span>¥{{orderInfo.order && orderInfo.order.coupon_price ? orderInfo.order.coupon_price : '0'}}</span>
						</div>
						<div class="priceItem">
							实付款
							<span class="cost">¥ {{orderInfo.order && orderInfo.order.pay_price ? orderInfo.order.pay_price : '0'}}</span>
						</div>
					</div>
					<div class="title" style="margin-top: .08rem;">
						订单信息
					</div>
					<div class="orderTimeBox">
						<div class="orderTimeItem">
							创建时间
							<span>{{orderInfo.order && orderInfo.order.create_time ? orderInfo.order.create_time : ''}}</span>
						</div>
						<div class="orderTimeItem">
							成交时间
							<span>{{orderInfo.order && orderInfo.order.create_time ? orderInfo.order.create_time : ''}}</span>
						</div>
					</div>
					<div class="service" @click="severPop = true">立即咨询</div>
				</div>
				<div class="orderFinishInfoBox" v-if="$route.query.type == 4">
					<div class="title">
						付款详情
					</div>
					<div class="priceBox">
						<div class="priceItem">积分总额
							<span>{{orderInfo.order && orderInfo.order.order_price ? orderInfo.order.order_price : '0'}}积分</span>
						</div>
						<div class="priceItem">兑换数量
							<span>{{orderInfo.order && orderInfo.order.num ? orderInfo.order.num : '0'}}</span>
						</div>
					</div>
					<!-- <div class="priceBox">
						<div class="priceItem">商品总价 <span>¥ 69.8</span></div>
						<div class="priceItem">优惠 <span>¥ 69.8</span></div>
						<div class="priceItem">实付款 <span class="cost">¥ 69.8</span></div>
					</div> -->
					<div class="title" style="margin-top: .08rem;">
						订单信息
					</div>
					<div class="orderTimeBox">
						<div class="orderTimeItem">创建时间
							<span>{{orderInfo.order && orderInfo.order.create_time ? orderInfo.order.create_time : ''}}</span>
						</div>
						<div class="orderTimeItem">成交时间
							<span>{{orderInfo.order && orderInfo.order.create_time ? orderInfo.order.create_time : ''}}</span>
						</div>
					</div>
					<div class="service" @click="severPop = true">立即咨询</div>
				</div>
			</div>
		</div>
		<div class="severInfoPop" v-if="severPop">
			<div class="centerContent">
				<img class="sveerIcon" src="../assets/Home/sveerIcon.png" />
				<div class="email">
					客服邮箱：{{email}}
				</div>
				<div class="QQ">
					客服 QQ：{{qqNum}}
				</div>
				<div class="ok" @click="severPop = false">
					好的
				</div>
			</div>
		</div>
		<UserBuyAgreeDialog :show="userBuy" @close="userBuy = false" />
	</div>
</template>

<script>
	import ImgAallery from '../components/ImgAallery.vue'
	import UserBuyAgreeDialog from '../components/UserBuyAgreeDialog.vue'
	export default {
		name: 'OrderDetails',
		components: {
			ImgAallery,
			UserBuyAgreeDialog
		},
		data() {
			return {
				userBuy: false,
				email: '',
				qqNum: '',
				severPop: false,
				images: ['https://img0.baidu.com/it/u=410223476,4138599093&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=750',
					'https://img2.baidu.com/it/u=2612741288,182099192&fm=253&fmt=auto&app=138&f=JPEG?w=513&h=500',
				],
				orderInfo: {},
				routerLinks: [{
					path: '/personal-center',
					title: '图片订单',
					query: {}
				}],
			}
		},
		mounted() {
			this.configData()
			if (this.$route.query.type == 1) {
				this.imgOrderOetails()
				this.routerLinks = [{
					path: '/personal-center',
					title: '图片订单',
					query: {
						menuId: 12,
					}
				}]
			}
			if (this.$route.query.type == 2) {
				this.makeOrderOetails()
				this.routerLinks = [{
					path: '/personal-center',
					title: '定制订单',
					query: {
						menuId: 13,
					}
				}]
			}

			if (this.$route.query.type == 3) {
				this.marketOrderOetails()
				this.routerLinks = [{
					path: '/personal-center',
					title: '周边订单',
					query: {
						menuId: 14,
					}
				}]
			}

			if (this.$route.query.type == 4) {
				this.integralOrderDetails()
				this.routerLinks = [{
					path: '/personal-center',
					title: '积分订单',
					query: {
						menuId: 15,
					}
				}]
			}
		},
		methods: {
			configData() {
				this.$api.post('/Other/config', {}).then(res => {
					if (res.code == 1) {
						res.data.forEach(item => {
							if (item.title == 'kf_email') {
								this.email = item.value
							}
							if (item.title == 'kf_qq') {
								this.qqNum = item.value
							}
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			imgOrderOetails() {
				this.$api.post('/Hua/huashi_order_details', {
					id: this.$route.query.orderId
				}).then(res => {
					if (res.code == 1) {
						this.orderInfo = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			makeOrderOetails() {
				this.$api.post('/Hua/dz_order_detail', {
					id: this.$route.query.orderId
				}).then(res => {
					if (res.code == 1) {
						this.orderInfo = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			marketOrderOetails() {
				this.$api.post('/Order/order_details', {
					id: this.$route.query.orderId
				}).then(res => {
					if (res.code == 1) {
						this.orderInfo = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			integralOrderDetails() {
				this.$api.post('/OrderIntegral/integral_order_details', {
					order_id: this.$route.query.orderId
				}).then(res => {
					if (res.code == 1) {
						this.orderInfo = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//图片订单获取订单状态
			getImgStatusName(item) {
				if (item.pay_status == 0) {
					if (item.status == 4) {
						return '已取消'
					} else {
						return '待支付'
					}
				} else {
					if (item.status == 3) {
						return '已完成'
					}
				}
			},
			//定制图片订单获取订单状态
			getMakeStatusName(item) {
				if (item.status == 1) {
					return '画师待确认'
				} else if (item.status == 2) {
					return '待支付'
				} else if (item.status == 3) {
					return '创作中'
				} else if (item.status == 4) {
					return '已完成'
				} else if (item.status == 5) {
					return '已取消'
				}
			},
			//获取周边市场的订单状态
			getMarketStatusName(item) {
				if (item.order) {
					if (item.order.pay_status == 0) {
						if (item.order.status == 4) {
							return '已取消'
						} else {
							return '待支付'
						}
					} else {
						if (item.order.status == 1 || item.order.status == 2) {
							return '进行中'
						} else if (item.order.status == 3) {
							return '已完成'
						} else if (item.order.status == 4) {
							return '已取消'
						}
					}
				} else {
					return '已取消'
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.personal-center-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
		position: relative;

		.personalBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
		z-index: 1;
	}

	.orderInfoBox {
		margin-top: .16rem;
		display: flex;
		justify-content: space-between;

		.goodsInfoBox {
			display: flex;
			flex-direction: column;
			width: 8.95rem;
			padding: .32rem .24rem .24rem;
			background: #FFFFFF;
			box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			border-radius: .12rem;
		}

		.orderStatus {
			font-weight: 700;
			font-size: .24rem;
			color: #000000;
			line-height: .32rem;
		}

		.addressInfoBox {
			margin-top: .24rem;
			display: flex;
			align-items: center;

			.icon {
				width: .32rem;
				height: .32rem;
			}

			.addressInfo {
				margin-left: .12rem;
				display: flex;
				flex-direction: column;

				.address {
					font-weight: 500;
					font-size: .14rem;
					color: #1C1C1C;
				}

				.namePhone {
					margin-top: .02rem;
					font-weight: 400;
					font-size: .12rem;
					color: #1C1C1C;
				}
			}
		}

		.userInfoBox {
			margin-top: .24rem;
			display: flex;
			align-items: center;

			.avatar {
				width: .44rem;
				height: .44rem;
				border-radius: 50%;
				overflow: hidden;
				object-fit: cover;
			}

			.nickname {
				margin-left: .16rem;
				font-weight: 500;
				font-size: .18rem;
				color: #312C28;
			}
		}

		.integralOrder {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-top: .24rem;
			border-top: .01rem solid #CCCCCC;

			.imgInfoBox {
				display: flex;
				align-items: center;

				.makeGoodsImg {
					width: 1rem;
					height: 1rem;
					border-radius: .08rem;
					overflow: hidden;
					object-fit: cover;
				}

				.imgInfo {
					width: 2.4rem;
					margin-left: .16rem;
					display: flex;
					flex-direction: column;

					.goodsTitle {
						font-weight: 700;
						font-size: .16rem;
						color: #000000;
						line-height: .22rem;
					}

					.goodsDesc {
						margin-top: .08rem;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						line-height: .16rem;
					}
				}
			}

			.goodsPrice {
				display: flex;
				flex-direction: column;
				align-items: flex-end;

				.price {
					display: flex;
					align-content: center;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;
				}

				.num {
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
				}
			}
		}

		.imgOrder {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-top: .24rem;
			border-top: .01rem solid #CCCCCC;

			.imgInfoBox {
				display: flex;
				align-items: center;

				.makeGoodsImg {
					width: 1rem;
					height: 1rem;
					border-radius: .08rem;
					overflow: hidden;
					object-fit: cover;
				}

				.goodsImg {
					width: .76rem;
					height: 1.02rem;
					border-radius: .08rem;
					overflow: hidden;
					object-fit: cover;
				}

				.imgInfo {
					width: 2.4rem;
					margin-left: .16rem;
					display: flex;
					flex-direction: column;

					.goodsTitle {
						font-weight: 700;
						font-size: .16rem;
						color: #000000;
						line-height: .22rem;
					}

					.goodsDesc {
						margin-top: .08rem;
						font-weight: 400;
						font-size: .12rem;
						color: #333333;
						line-height: .16rem;
					}

					.tips {
						margin-top: .12rem;
						display: flex;
						align-items: center;

						.tip {
							height: .26rem;
							padding: 0 .08rem;
							border-radius: .13rem;
							border: .01rem solid #A88653;
							line-height: .24rem;
							font-weight: 400;
							font-size: .12rem;
							color: #7C3E0B;
						}
					}
				}
			}

			.goodsPrice {
				display: flex;
				flex-direction: column;
				align-items: flex-end;

				.price {
					display: flex;
					align-content: center;
					font-weight: 700;
					font-size: .14rem;
					color: #000000;

					span {
						font-weight: 400;
					}
				}

				.num {
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
				}
			}
		}

		.goodsInfo {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			padding-top: .24rem;
			border-top: .01rem solid #CCCCCC;

			.descTips {
				display: flex;
				flex-direction: column;

				.desc {
					width: 3.68rem;
					font-weight: 400;
					font-size: .12rem;
					color: #333333;
				}

				.tips {
					margin-top: .12rem;
					display: flex;
					align-items: center;

					.tip {
						height: .26rem;
						padding: 0 .08rem;
						border-radius: .13rem;
						border: .01rem solid #A88653;
						line-height: .24rem;
						font-weight: 400;
						font-size: .12rem;
						color: #7C3E0B;
					}
				}
			}
		}

		.timeBox {
			margin-top: .24rem;
			width: 8.47rem;
			display: flex;
			flex-direction: column;
			background: #FAEFDD;
			padding: .16rem .16rem;
			border-radius: .06rem;

			.timeTitle {
				font-weight: 700;
				font-size: .14rem;
				color: #333333;
			}

			.timeDesc {
				margin-top: .06rem;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}
		}
	}

	.orderFinishInfoBox {
		display: flex;
		align-self: self-start;
		flex-direction: column;
		width: 2.88rem;
		background: #FFFFFF;
		padding: .24rem .24rem;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;

		.title {
			margin-bottom: .06rem;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
			line-height: .22rem;
		}

		.priceBox {
			display: flex;
			flex-direction: column;

			.priceItem:nth-child(3) {
				margin-top: 0rem;
			}

			.priceItem {
				margin-top: .08rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;

				span {
					font-weight: 600;
					font-size: .14rem;
					color: #333333;
				}

				.cost {
					font-weight: 700;
					font-size: .2rem;
				}
			}
		}

		.orderTimeBox {
			display: flex;
			flex-direction: column;

			.orderTimeItem {
				margin-top: .08rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}
		}

		.service {
			margin: .32rem auto 0;
			width: 2.4rem;
			height: .52rem;
			background: #E29358;
			border-radius: .06rem;
			font-weight: 500;
			font-size: .16rem;
			color: #252525;
			line-height: .52rem;
			text-align: center;
			cursor: pointer;
		}
	}

	.payInfoBox {
		display: flex;
		align-self: flex-start;
		flex-direction: column;
		width: 2.88rem;
		background: #FFFFFF;
		padding: .24rem .24rem;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;

		.title {
			margin-bottom: .06rem;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
			line-height: .22rem;
		}

		.orderPriceBox {
			margin-top: .1rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.itemTitle {
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}

			.priceBox {
				display: flex;
				align-items: center;

				.price {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .2rem;
					color: #FF0100;

					.unit {
						font-weight: 400;
						font-size: .14rem;
					}
				}


				.arrow {
					margin-left: .04rem;
					width: .06rem;
					height: .1rem;
				}
			}
		}

		.payWayBox {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 2.4rem;
			height: .96rem;
			background: #FFFFFF;
			border-radius: .08rem;
			border: .01rem solid #EFD8B8;
			padding: .2rem .16rem;

			.payItem {
				display: flex;
				align-items: center;
				font-weight: 500;
				font-size: .14rem;
				color: #333333;
				line-height: .2rem;

				.checkIcon {
					margin-right: .16rem;
					width: .14rem;
					height: .14rem;
				}

				.payIcon {
					margin-right: .06rem;
					width: .16rem;
					height: .16rem;
				}
			}
		}

		.agreementBox {
			margin-top: .12rem;
			display: flex;
			align-items: center;
			font-size: .12rem;

			.checkIcon {
				margin-right: .06rem;
				width: .14rem;
				height: .14rem;
			}

			.userAgreement {
				color: #E29358;
				cursor: pointer;
			}
		}

		.costButNow {
			margin-top: .4rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.costBox {
				display: flex;
				flex-direction: column;
				font-weight: 400;
				font-size: .12rem;
				color: #333333;

				.cost {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .24rem;
					color: #FF0000;

					.unit {
						font-weight: 400;
						font-size: .14rem;
					}
				}
			}

			.buyNow {
				width: 1rem;
				height: .48rem;
				background: #E29358;
				border-radius: .06rem;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
				line-height: .48rem;
				text-align: center;
			}
		}
	}

	.severInfoPop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 100;

		.centerContent {
			display: flex;
			flex-direction: column;
			width: 3.1rem;
			background: #FFFFFF;
			border-radius: .12rem;

			.sveerIcon {
				width: .64rem;
				height: .64rem;
				margin: .4rem auto 0;
			}

			.email,
			.QQ {
				margin-top: .24rem;
				margin-left: .24rem;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
			}

			.ok {
				margin: .24rem auto;
				width: 1.76rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}
</style>